import Characteristic from './characteristic';

export default Characteristic;
export { Characteristic };